import React from "react";
import { Link } from "react-router-dom";
import CountUp from "react-countup";
import { Eye, Users, Star, Lock } from "lucide-react";

export default function RecruiterInsightsCard({ data }) {
  if (!data) return null;

  return (
    <div className="glass-panel rounded-2xl p-6 transition-all duration-300 ease-out hover:-translate-y-1 hover:border-white/20 hover:shadow-[0_12px_40px_rgba(0,0,0,0.35)]" data-testid="recruiter-insights-card">
      <span className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400 flex items-center gap-2 mb-4">
        <span className="w-6 h-6 rounded-md bg-emerald-400/10 flex items-center justify-center"><Eye className="w-3.5 h-3.5 text-emerald-400" /></span> Recruiter Interest
      </span>

      {!data.recruiter_visible ? (
        <p className="text-xs text-slate-400 flex items-start gap-2" data-testid="recruiter-insights-hidden-message">
          <Lock className="w-3.5 h-3.5 shrink-0 mt-0.5" />
          Your profile is hidden from recruiter search.{" "}
          <Link to="/profile" className="text-indigo-400 hover:text-indigo-300 whitespace-nowrap">Enable visibility →</Link>
        </p>
      ) : (
        <div className="grid grid-cols-3 gap-3 text-center">
          <div data-testid="recruiter-insights-total-views">
            <p className="font-heading text-xl font-bold text-white tabular-nums"><CountUp end={data.total_views} duration={1.2} /></p>
            <p className="text-[10px] text-slate-400 mt-0.5">Profile Views</p>
          </div>
          <div data-testid="recruiter-insights-unique-recruiters">
            <div className="flex items-center justify-center gap-1 text-white"><Users className="w-3.5 h-3.5 text-indigo-400" /><span className="font-heading text-xl font-bold tabular-nums"><CountUp end={data.unique_recruiters} duration={1.2} /></span></div>
            <p className="text-[10px] text-slate-400 mt-0.5">Recruiters</p>
          </div>
          <div data-testid="recruiter-insights-shortlisted">
            <div className="flex items-center justify-center gap-1 text-white"><Star className="w-3.5 h-3.5 text-[#FBBF24]" /><span className="font-heading text-xl font-bold tabular-nums"><CountUp end={data.shortlisted_count} duration={1.2} /></span></div>
            <p className="text-[10px] text-slate-400 mt-0.5">Shortlisted</p>
          </div>
        </div>
      )}
      {data.recruiter_visible && data.views_this_month > 0 && (
        <p className="text-[11px] text-slate-400 mt-3 text-center" data-testid="recruiter-insights-month-note">{data.views_this_month} view{data.views_this_month !== 1 ? "s" : ""} in the last 30 days</p>
      )}
    </div>
  );
}
